module.exports = __webpack_public_path__ + "img/impostor-minigolf.bf770f0e.png";